import React from 'react';

function formatDate(dateStr) {
  if (!dateStr) return '—';
  const [y, m, d] = dateStr.slice(0, 10).split('-');
  if (!y || !m || !d) return '—';
  return `${d}/${m}/${y}`;
}

export default function PersonResultCard({ person, onClick }) {
  const initials = person.name.split(' ').map(n => n[0]).slice(0, 2).join('').toUpperCase();

  return (
    <div className="person-card" onClick={onClick}>
      <div className="person-avatar">{initials}</div>
      <div className="person-info">
        <h3>{person.name}</h3>
        <p className="dates-icons">
          {person.birth_date && (
            <span className="date-item birth-date" title="Data de nascimento">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor" stroke="none">
                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
              </svg>
              {formatDate(person.birth_date)}
            </span>
          )}
          {person.death_date && (
            <span className="date-item death-date" title="Data de falecimento">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor" stroke="none">
                <path d="M10 3h4v5h5v4h-5v9h-4v-9H5V8h5z" />
              </svg>
              {formatDate(person.death_date)}
            </span>
          )}
          {!person.birth_date && !person.death_date && '—'}
        </p>
      </div>
      <div className="person-arrow">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="9 18 15 12 9 6"></polyline>
        </svg>
      </div>
    </div>
  );
}
